import { FC, ReactNode } from 'react';

import { cn } from '@/lib/utils';

interface IProps {
  children: ReactNode;
  title?: string | ReactNode;
  subtitle?: string | ReactNode;
  footer?: ReactNode;
  className?: string | '';
}

const PageContainer: FC<IProps> = ({
  children,
  title,
  subtitle,
  footer,
  className,
}) => {
  return (
    <div
      className={cn(
        'w-full 2xl:px-0 2xl:max-w-[1200px] mx-auto px-5 py-30 flex flex-col flex-grow gap-30 overflow-auto',
        `${className}`
      )}
    >
      {(title || subtitle) && (
        <div className={'flex flex-col gap-4 mx-4'}>
          {title && (
            <h1 className={'text-[32px] font-bold leading-[1.3125]'}>
              {title}
            </h1>
          )}
          {subtitle && (
            <p className={'text- font-medium leading-[1.5]'}>{subtitle}</p>
          )}
        </div>
      )}

      <div className={'flex flex-col flex-grow mx-2'}>{children}</div>

      {footer && <div className={'flex-shrink-0'}>{footer}</div>}
    </div>
  );
};

export default PageContainer;
